import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
  identityApiRef,
} from '@backstage/core-plugin-api';
import { withEnvGuard } from '@traton/devportal-env-kit-app';
import { rootRouteRef } from './routes';
import { announcementApiRef } from './api/AnnouncementApi';
import { AnnouncementClient } from './api/AnnouncementClient';

export const announcementPlugin = createPlugin({
  id: 'announcement',
  apis: [
    createApiFactory({
      api: announcementApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
        identityApi: identityApiRef,
      },
      factory: ({ discoveryApi, fetchApi, identityApi }) =>
        new AnnouncementClient({ discoveryApi, fetchApi, identityApi }),
    }),
  ],
  routes: {
    root: rootRouteRef,
  },
});

export const AnnouncementPage = announcementPlugin.provide(
  createRoutableExtension({
    name: 'AnnouncementPage',
    component: () =>
      import('./components/AnnouncementAdminPage').then(m =>
        withEnvGuard(m.AnnouncementAdminPage, 'announcement'),
      ),
    mountPoint: rootRouteRef,
  }),
);
